var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'CoreGroupbuyingsListV2'
      }
    }
  }, [_vm._v("團購管理 ")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("團購列表")])], 1)], 1)])]), _c('b-card', [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('div', {
    staticClass: "row mb-2 align-items-center"
  }, [_c('div', {
    staticClass: "col-12 col-xl-2"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("團購列表")])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('b-form-group', {
    attrs: {
      "disabled": _vm.readonly
    }
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "商品名稱"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.product.title,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "title", $$v);
      },
      expression: "product.title"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "商品規格"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.product.skus[0].sku_name,
      callback: function callback($$v) {
        _vm.$set(_vm.product.skus[0], "sku_name", $$v);
      },
      expression: "product.skus[0].sku_name"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "商品說明",
      "label-for": "product_description"
    }
  }, [_c('b-form-textarea', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0 col-12 col-xl-6",
    attrs: {
      "id": "title"
    },
    model: {
      value: _vm.product.description,
      callback: function callback($$v) {
        _vm.$set(_vm.product, "description", $$v);
      },
      expression: "product.description"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "商品店內碼(選填)"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.product.skus[0].sku_outer_code,
      callback: function callback($$v) {
        _vm.$set(_vm.product.skus[0], "sku_outer_code", $$v);
      },
      expression: "product.skus[0].sku_outer_code"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "商品條碼(選填)"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.product.skus[0].sku_serial_number,
      callback: function callback($$v) {
        _vm.$set(_vm.product.skus[0], "sku_serial_number", $$v);
      },
      expression: "product.skus[0].sku_serial_number"
    }
  })], 1)], 1)], 1)]), !_vm.readonly ? _c('div', {
    staticClass: "d-flex justify-content-center",
    staticStyle: {
      "margin-top": "80px"
    }
  }, [_c('b-button', {
    staticClass: "mr-4",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [[_vm._v("返回")]], 2), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm.isEdit ? [_vm._v("確認編輯")] : _vm._e(), _vm.isCreate ? [_vm._v("確認新增")] : _vm._e()], 2)], 1) : _vm._e()])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }